var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SampleCustomersConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
import { sampleCustomersConfigSchemaValidation } from '../validations.generated';
export const sampleCustomersConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:SampleChurnConfig',
    type: 'object',
    properties: {}
};
let SampleCustomersConfig = SampleCustomersConfig_1 = class SampleCustomersConfig extends ToolConfig {
    constructor(customFormats) {
        super(ToolType.SAMPLE_CUSTOMERS, customFormats);
        JSON.validate(this, SampleCustomersConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return SampleCustomersConfig_1.outs[0];
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return SampleCustomersConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return SampleCustomersConfig_1.outs;
    }
    static get ins() {
        return [];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.SAMPLE_CUSTOMERS.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.DATA], this.ins, this.outs, ['clients'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const columns = [
            new Column('Customer ID', 'string'),
            new Column('Age', 'number'),
            new Column('Gender', 'string'),
            new Column('Voicemail Plan', 'string'),
            new Column('Voicemail Messages', 'number'),
            new Column('Day Calls', 'number'),
            new Column('Day Mins', 'number'),
            new Column('Day Charge', 'number'),
            new Column('Eve Calls', 'number'),
            new Column('Eve Mins', 'number'),
            new Column('Eve Charge', 'number'),
            new Column('Night Calls', 'number'),
            new Column('Night Mins', 'number'),
            new Column('Night Charge', 'number'),
            new Column('Weeks Subscribed', 'number'),
            new Column('Customer Service Calls', 'number'),
            new Column('Canceled', 'boolean')
        ];
        const exp = tsb.export(this.outs[0]);
        for (const col of columns) {
            exp.makeNew(col, undefined, false);
        }
        exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    // eslint-disable-next-line class-methods-use-this
    isValidForCalc(iConfigHelper, ins) {
        return ToolValidationState.VALID;
    }
};
SampleCustomersConfig = SampleCustomersConfig_1 = __decorate([
    JsonSchemaV2(sampleCustomersConfigSchema, sampleCustomersConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.SAMPLE_CUSTOMERS)
], SampleCustomersConfig);
export { SampleCustomersConfig };
//# sourceMappingURL=sampleCustomersConfig.js.map